import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5853c909")

_pushScopeId("data-v-5853c909")
const _hoisted_1 = {
  key: 0,
  class: "wrapper"
}
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ion_button = _resolveComponent("ion-button")

  return (_ctx.configs.featureFlags().showAlertBanner)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: ["bar", { hidden: !_ctx.message }]
        }, [
          _createVNode("span", {
            id: "header-alert-message",
            class: "message",
            innerHTML: _ctx.message
          }, null, 8, ["innerHTML"]),
          (_ctx.buttonText)
            ? (_openBlock(), _createBlock(_component_ion_button, {
                key: 0,
                id: "header-alert-button",
                size: "small",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('alert-click')))
              }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.buttonText), 1 /* TEXT */)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
})